import type { MonospaceSingleConstraint, MonospaceSingleConstraintField } from '#layers/data-model';
import { RStoreSchema } from '#imports';

export const SingleConstraintField = RStoreSchema.withItemType<MonospaceSingleConstraintField>().defineCollection({
	name: 'MonospaceSingleConstraintField',
	scopeId: 'monospace-default',
	getKey: (item) => `${item.constraintId}__${item.constrainedFieldId}__${item.referencedFieldId}`,
	meta: {
		defaultFields: ['order', 'constraintId', 'constrainedFieldId', 'referencedFieldId'],
		useProjectSlug: true,
	},
});

export const SingleConstraint = RStoreSchema.withItemType<MonospaceSingleConstraint>().defineCollection({
	name: 'MonospaceSingleConstraint',
	scopeId: 'monospace-default',
	meta: {
		defaultFields: ['id', 'dbName'],
		useProjectSlug: true,
	},
});
